<template>
  <div>
    <Form
      page-title="Add a new Holiday"
      buttonName="Submit"
      :businessId="businessId"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="HolidaysForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import { submitAndNotify } from "@/helpers/utils";
import Form from "./Form";
import { createHoliday } from "@/API/HolidaysAPIs";
export default {
  name: "Create",
  props: ["isInList", "businessId"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async submit(formData) {
      const data = {
        businessId: formData.business_id,
        locales: formData.locales,
        dateRange: {
          startDate: formData.dateRange.startDate,
          endDate: formData.dateRange.endDate
        },
        business_id: formData.business_id,
        from: formData.from,
        to: formData.to
      };
      const callback = () => {
        this.$refs.HolidaysForm.resetForm();
      };
      submitAndNotify(this, createHoliday(data), callback);
    }
  }
};
</script>
<style></style>
